import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { api } from '@/api/api';
import { errors } from '@/middleware/errors';

const createStore = ({ initialState }: any = {}) => {
  const middleware: any = [api.middleware, errors];
  const store = configureStore({
    reducer: combineReducers({ [api.reducerPath]: api.reducer }),
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middleware),
    devTools: true,
  });
  setupListeners(store.dispatch);
  return store;
};

export { createStore };
